namespace TabAurous.Administration {
    export interface IntegrationForm {
        Type: Serenity.EnumEditor;
        IntegrationType: Serenity.LookupEditor;
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        Url: Serenity.StringEditor;
        AccessKey: Serenity.StringEditor;
        SecretKey: Serenity.StringEditor;
        RoleArn: Serenity.StringEditor;
        RefreshToken: Serenity.StringEditor;
    }

    export class IntegrationForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Integration';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IntegrationForm.init)  {
                IntegrationForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.PasswordEditor;

                Q.initFormType(IntegrationForm, [
                    'Type', w0,
                    'IntegrationType', w1,
                    'Username', w2,
                    'Password', w3,
                    'Url', w2,
                    'AccessKey', w2,
                    'SecretKey', w2,
                    'RoleArn', w2,
                    'RefreshToken', w2
                ]);
            }
        }
    }
}
